<template lang="pug">
.course
  .mask-cou(v-if="stage === 0||stage === 3",:class="{'zindex555' : stage === 3}")
    .mask1(v-if="stage === 3",style="height: 40%;",@click="start").hall1
    .mask1.hall2(v-if="stage === 0")
      img(src="../../assets/Noviceguide/line.png").line
      p.text-Explain(style="margin-top: 125%;")  可进入部门了解信息，完成任务
    button.start(@click="start",v-if="stage === 0") 开始体验
  .mask-Overall(v-if="stage !== 0&&stage !== 3")
    Welcome(:index="-1",@start="start",v-if="stage === 1")
    image-text(@start="start",v-if="stage === 2")
  right-column(style="z-index: 22222222;")
  div.right-Explain(v-if="stage === 0")
    div
      img(src="../../assets/Noviceguide/line3.png",style="right: 20px;").line
      p.text-Explain(style="right: 278%;")  返回大厅
    div
      img(src="../../assets/Noviceguide/line.png",style="top:30%;transform: rotate3d(-0.3, 1, 0, 180deg);").line
      p.text-Explain(style="top: 33%;right: 313%;") 搜索
      p.text-Explain(style="top: 45%;font-size: 14px;right: 15%;") 搜索相关资料 ，例如之前政策的情信息和国外相关政策信息等～
    div
      img(src="../../assets/Noviceguide/line1.png",style="top:55%;left:28%").line
      p.text-Explain(style="top: 65%;right: 182%;") 分析模型、工具和方法
      p.text-Explain(style="top: 78%;font-size: 14px;right: 80%;") 公共政策过程中合理使用可以帮助你做出更好的决策
    div
      img(src="../../assets/Noviceguide/line1.png",style="top:85%;left:28%").line
      p.text-Explain(style="top: 95%;right: 313%;") 笔记
      p.text-Explain(style="top: 108%;font-size: 14px;right: 66%;") 可以将你觉得有用的信息录入在笔记中，随时方便查看
  div.top-nav
    div.left-nav
      img.logo(:src="logoNav",:class="{'blur' : stage === 0}")
      p.text-Explain(style="margin-left: 120px;",v-if="stage === 0") 实训当前阶段
      div(:class="{'focus-div' : stage === 0}",style="display:inline-block")
        img(src="../../assets/Noviceguide/line.png",v-if="stage === 0").line1
        li(v-for='(v,idx) in list',:class="{active:idx === 0}").text {{v}}
    div(style='flex:1;')
    div.rigth-nav
      div(:class="{'focus-div' : stage === 0}",style="    display: inline-block;")
        img(src="../../assets/Noviceguide/line1.png",style="left: -100%;").line.line2
        p.text-Explain(style="margin-top: 130%;right: 171%;",v-if="stage === 0") 任务和通知
        p.text-Explain(style="margin-top: 170%;right: 171%;font-size: 14px;",v-if="stage === 0") 可进入任务场景
        i.icon-renwu1.iconfont( style='padding-right:8px;')
        p.task-text 任务
      p.task-text(style='color:#D8D8D8;padding-right: 8px;padding-left: 26px;display: inline-block;') |
      div(:class="{'focus-div' : stage === 0}",style="    display: inline-block;")
        img(src="../../assets/Noviceguide/line.png",v-if="stage === 0").line.rotate-180.line2
        p.text-Explain(style="margin-top: 110%;right: 50%;",v-if="stage === 0") 点击可退出实训
        p.task-text() 退出实训1
  div(v-if="stage === 3")
    .task-3(@click="start")
      Badge(dot)
        Icon.icon-renwu1.iconfont(:size='24',color='rgba(80, 143, 244, 1)')
      div.text-content 任务是完成整个实训的关键连接，要及时点击哦～
    img(src="../../assets/Noviceguide/小手.png", alt="提示",@click="start").finger
    div.text-Explain(style="z-index: 5555566;right: 9%;top: 23%;") 点击任务 或 部门都可进入任务场景中
  div.main-hall(v-for='(v,idx) in hallList',:class="`hall${idx}`") {{v.departmentName}}
    p.circular
</template>
<script>
import rightColumn from "@/components/doCase/RightColumn"; // 右侧按钮控件
import Welcome from "./welcome"; // 欢迎进入控件
import imageText from "./Image&Text"; // 欢迎进入控件
export default {
  components: {
    "right-column": rightColumn,
    Welcome,
    imageText
  },
  data() {
    return {
      stage: 0,
      list: ["预算绩效目标管理", "事中绩效跟踪监控", "事后绩效评价"],
      hallList: [
        { departmentName: "我的办公室" },
        { departmentName: "领导办公室" },
        { departmentName: "民意调查中心" },
        { departmentName: "财政部" }
      ] // 单阶段的所有部门
    };
  },
  mounted() {
  },
  methods: {
    start() {
      this.stage += 1;
      if (this.stage >= 4) {
        this.$emit("start");
      }
    }
  }
};
</script>
<style lang="stylus" scoped>
@import 'css.styl'
.mask-Overall
  background #00000099
  width 100vw
  height 100vh
  position fixed
  top 0
  left 0
  z-index 999999999
</style>
